import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useProviderCodes, useRequestCoupon } from "@jti/rest-api";
import { Toaster } from "../../components/Toaster";
import { useConfig } from "../../providers/useConfig";
import { useTranslations } from "../../providers/useTranslations";
import { DEPRECATED_Typography } from "../DEPRECATED_Typography";
import { Loading } from "../Loading";
import { Promotion } from "./Promotion/Promotion";
import styles from "./PromotionCodes.module.scss";
export const PromotionCodes = ({ title, description, successMessage, errorMessage, promotions, }) => {
    const [activePromotionCode, setActivePromotionCode] = useState(null);
    const { ISO_COUNTRY_CODE } = useConfig();
    const { __ } = useTranslations();
    const { providerCodes, isProviderCodesLoading, isProviderCodesError, providerCodesError } = useProviderCodes(ISO_COUNTRY_CODE);
    const { requestCoupon, isRequestCouponLoading } = useRequestCoupon();
    const handlePromotionClick = async (code) => {
        setActivePromotionCode(code);
        try {
            await requestCoupon(code);
            toast.success(successMessage);
        }
        catch (error) {
            toast.error(error.message || errorMessage);
        }
        finally {
            setActivePromotionCode(null);
        }
    };
    const filteredPromotions = useMemo(() => promotions.filter((promotion) => providerCodes?.includes(promotion.code)), [promotions, providerCodes]);
    return (_jsxs("div", { className: styles.container, children: [_jsx(Toaster, {}), (isProviderCodesLoading || isRequestCouponLoading) && (_jsx("div", { className: styles.loadingOverlay, children: _jsx(Loading, { dataTestId: "loading-spinner" }) })), _jsxs("div", { className: styles.textContainer, children: [_jsx(DEPRECATED_Typography, { className: styles.title, color: "grey-5", children: title }), _jsx(DEPRECATED_Typography, { className: styles.description, color: "grey-6", children: description })] }), isProviderCodesError && (_jsx(DEPRECATED_Typography, { type: "p1", color: "grey-6", children: providerCodesError.message })), !isProviderCodesError && !isProviderCodesLoading && filteredPromotions.length === 0 && (_jsx(DEPRECATED_Typography, { type: "p1", color: "grey-6", children: __("libs.ui.promotion.no_promotions") })), filteredPromotions.length > 0 && (_jsx("div", { className: styles.promotionsContainer, children: filteredPromotions.map((promotion) => (_jsx(Promotion, { code: promotion.code, imageUrl: promotion.imageUrl, onClick: () => handlePromotionClick(promotion.code), isActive: activePromotionCode === promotion.code }, promotion.code))) }))] }));
};
//# sourceMappingURL=PromotionCodes.js.map